<template>
  <div id="projects">
    <PageHero title="Projects" lede="Things we build and share." />
    <section class="section">
      <div class="container">
        <div class="prose stack">
          <span class="eyebrow">Open source</span>
          <h2>Synoptik</h2>
          <p class="lede"><b>A software knowledge engine for teams that build with AI coding agents.</b></p>

          <p>Coding agents have no long-term memory. Each session they re-read
            the same files to rediscover the same relationships, and the reasoning
            behind the code, which lives in requirements, designs, and decisions,
            is lost or re-derived badly every time.</p>

          <p>Synoptik indexes source code and the documents that describe it into one
            knowledge graph. An agent or a developer can ask where something is
            defined, who calls it, what a change would reach, which decisions
            govern an area, and which tests cover it, and get an answer instead of
            a file dump. Answers combine lexical and semantic search, and the
            index follows the working tree as you edit, so it describes the code
            as it is now rather than the last commit.</p>

          <p>Synoptik is reached through a console, a REST API, and an MCP server, so
            it works with Claude Code and other agents. It also has a web
            interface for browsing the index, editing documents, and interacting
            with agents. It reads Common Lisp,
            JavaScript, Python, YAML, and Markdown, and it ships a document
            workflow in which requirements, designs, plans, reviews, and bugs are
            linked to each other and to the code they affect. That keeps the
            written record of why the code is the way it is available to the next
            session.</p>

          <p>It is designed for teams of one to a hundred developers working
            across several related repositories with strong CI. It is not a task
            tracker or a code review tool. This site is itself indexed with
            Synoptik.</p>

          <p>Synoptik is open source under the MIT license.</p>
          <div class="btn-row">
            <a class="btn" href="https://github.com/beberman/Synoptik" target="_blank"
               rel="noopener" @click="$analytics.logEvent('Synoptik GitHub')">View Synoptik on GitHub</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageHero from '@/components/PageHero'

export default {
    name: 'Projects',
    title: 'Projects - Ten Factor Growth',
    components: { PageHero },
    mounted() {
        this.$analytics.logEvent('Projects')
    }
}
</script>
